
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { CoordinatesState, CoordinatesStateResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<CoordinatesStateResponse, CoordinatesStateResponse>) => response?.data?.state;
const getError = (response?: SWRResponse<CoordinatesStateResponse, CoordinatesStateResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<CoordinatesStateResponse, CoordinatesStateResponse>) => ({});

const useGetCoordinatesState = (query?: Partial<CoordinatesState>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new CoordinatesState(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetCoordinatesState;